function desligar(data) {
    const { busca, form } = data;

    const { beneficiarios, motivosExclusao } = busca;

    return {
        ...beneficiarios[0],
        tipo: beneficiarios[0].tipo === 'T' ? 'Titular' : 'Dependente',
        ...form,
        motivosDesligamento: motivosExclusao,
    };
}

export { desligar };
